import { normaliserActivitesDomaine, type ActivitesDomaine } from "@champ-erp/contracts";
import { useMemo } from "react";

import { resoudreMembershipActive } from "./tenant-actif.js";
import { useMe } from "./use-me.js";

type Activite = keyof ActivitesDomaine;

/** Préférences de navigation uniquement : ne remplace jamais une permission. */
export function navigationActivites(activites: ActivitesDomaine | null) {
  const suit = (activite: Activite) => !activites || activites[activite] !== "non_pratique";
  const realise = (activite: Activite) =>
    !activites || ["au_domaine", "les_deux"].includes(activites[activite]);
  const confie = (activite: Activite) =>
    !!activites && ["confie", "les_deux"].includes(activites[activite]);
  const visible = (path: string): boolean => {
    if (path.startsWith("/vignoble") || path.startsWith("/vendange"))
      return suit("vignoble_vendanges");
    if (path.startsWith("/cuverie/pressurage")) return suit("pressurage");
    if (
      path.startsWith("/cuverie/preparations-tirage") ||
      path.startsWith("/cave/tirages") ||
      path.startsWith("/cave/degorgements")
    )
      return suit("elaboration_bouteilles");
    if (path.startsWith("/cave/assemblages")) return suit("vinification_assemblages");
    if (path === "/cuverie" || path.startsWith("/cuverie/intrants-stock"))
      return (
        suit("pressurage") || suit("vinification_assemblages") || realise("elaboration_bouteilles")
      );
    if (path.startsWith("/cuverie/")) return suit("vinification_assemblages");
    if (path.startsWith("/cave/habillage")) return suit("habillage");
    if (
      path.startsWith("/ventes") ||
      path.startsWith("/expedition") ||
      path.startsWith("/boutique-admin")
    )
      return suit("commercialisation");
    // Plans, stocks, cuvées, conformité et réglages restent transversaux.
    return true;
  };
  return { activites, suit, realise, confie, visible };
}

export function useActivitesDomaine() {
  const { data } = useMe();
  const activites = resoudreMembershipActive(data)?.domaine.activites;
  return useMemo(() => navigationActivites(normaliserActivitesDomaine(activites)), [activites]);
}
